module.exports = __webpack_public_path__ + "static/media/ic_template_16.d53d7a59.png";